import { useState, useEffect } from 'react'

const NOTIFICATIONS = [
  {
    name: 'Marcos G.',
    city: 'Buenos Aires',
    pack: 'PACK COMPLETO',
    time: '4 min',
    img: 'https://randomuser.me/api/portraits/men/32.jpg',
  },
  {
    name: 'Valentina R.',
    city: 'Córdoba',
    pack: 'PACK COMPLETO',
    time: '7 min',
    img: 'https://randomuser.me/api/portraits/women/44.jpg',
  },
  {
    name: 'Diego M.',
    city: 'Rosario',
    pack: 'PACK COMPLETO',
    time: '2 min',
    img: 'https://randomuser.me/api/portraits/men/45.jpg',
  },
  {
    name: 'Luciana F.',
    city: 'Mendoza',
    pack: 'PACK COMPLETO',
    time: '11 min',
    img: 'https://randomuser.me/api/portraits/women/28.jpg',
  },
  {
    name: 'Sebastián P.',
    city: 'CABA',
    pack: 'PACK COMPLETO',
    time: '6 min',
    img: 'https://randomuser.me/api/portraits/men/22.jpg',
  },
  {
    name: 'Carolina M.',
    city: 'Santa Fe',
    pack: 'PACK COMPLETO',
    time: '3 min',
    img: 'https://randomuser.me/api/portraits/women/65.jpg',
  },
  {
    name: 'Andrés V.',
    city: 'Tucumán',
    pack: 'PACK COMPLETO',
    time: '9 min',
    img: 'https://randomuser.me/api/portraits/men/67.jpg',
  },
  {
    name: 'Florencia T.',
    city: 'La Plata',
    pack: 'PACK COMPLETO',
    time: '1 min',
    img: 'https://randomuser.me/api/portraits/women/12.jpg',
  },
]

export function useSocialProof() {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const initialTimeout = setTimeout(() => {
      setIsVisible(true)
    }, 5000)
    return () => clearTimeout(initialTimeout)
  }, [])

  useEffect(() => {
    let hideTimeout: NodeJS.Timeout
    let showNextTimeout: NodeJS.Timeout

    if (isVisible) {
      hideTimeout = setTimeout(() => {
        setIsVisible(false)
      }, 5000)
    } else {
      showNextTimeout = setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % NOTIFICATIONS.length)
        setIsVisible(true)
      }, 15000)
    }

    return () => {
      clearTimeout(hideTimeout)
      clearTimeout(showNextTimeout)
    }
  }, [isVisible])

  const dismiss = () => setIsVisible(false)

  return {
    notification: NOTIFICATIONS[currentIndex],
    isVisible,
    dismiss,
  }
}
